import React from 'react';
import { useMonitoreo } from './MonitoreoContext';
import '../../styles/home.css';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

export default function SelectJerarquia() {
    const {
        hierAreas,
        hierCeldasList,
        hierLinesByArea: filteredHierLines,
        selectedHierArea,
        setSelectedHierArea,
        selectedHierLinea,
        setSelectedHierLinea,
        selectedHierCelda,
        setSelectedHierCelda,
    } = useMonitoreo();

    const plantaNombre = process.env.REACT_APP_PLANT_NAME || 'Planta';

    const handleAreaChange = (e) => {
        const val = e.target.value;
        const area = val !== '' ? hierAreas.find((a) => String(a.area1) === String(val)) || null : null;
        setSelectedHierArea(area);
    };

    const handleLineaChange = (e) => {
        const val = e.target.value;
        const linea = val !== '' ? filteredHierLines.find((l) => String(l.id) === String(val)) || null : null;
        setSelectedHierLinea(linea);
    };

    const handleCeldaChange = (e) => {
        const val = e.target.value;
        const celda = val !== '' ? hierCeldasList.find((c) => String(c.id) === String(val)) || null : null;
        setSelectedHierCelda(celda);
    };

    return (
        <div className="selectJerarquia">
            {/* Planta — fija */}
            <FormControl className="selectJerarquia-item">
                <InputLabel shrink>Planta</InputLabel>
                <Select value="planta" disabled>
                    <MenuItem value="planta">{plantaNombre}</MenuItem>
                </Select>
            </FormControl>

            {/* Área */}
            <FormControl className="selectJerarquia-item">
                <InputLabel id="mon-select-area-label">Área</InputLabel>
                <Select
                    labelId="mon-select-area-label"
                    value={selectedHierArea?.area1 ?? ''}
                    onChange={handleAreaChange}
                >
                    <MenuItem value="">Todas las áreas</MenuItem>
                    {hierAreas.map((area) => (
                        <MenuItem key={area.area1} value={area.area1}>
                            {area.nombre}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>

            {/* Línea — solo cuando hay área */}
            {selectedHierArea && (
                <FormControl className="selectJerarquia-item">
                    <InputLabel id="mon-select-linea-label">Línea</InputLabel>
                    <Select
                        labelId="mon-select-linea-label"
                        value={selectedHierLinea?.id ?? ''}
                        onChange={handleLineaChange}
                    >
                        <MenuItem value="">Todas las líneas</MenuItem>
                        {filteredHierLines.map((line) => (
                            <MenuItem key={line.id} value={line.id}>
                                {line.nombre}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            )}

            {/* Celda — solo cuando hay línea */}
            {selectedHierLinea && (
                <FormControl className="selectJerarquia-item">
                    <InputLabel id="mon-select-celda-label">Celda</InputLabel>
                    <Select
                        labelId="mon-select-celda-label"
                        value={selectedHierCelda?.id ?? ''}
                        onChange={handleCeldaChange}
                    >
                        <MenuItem value="">Todas las celdas</MenuItem>
                        {hierCeldasList.map((celda) => (
                            <MenuItem key={celda.id} value={celda.id}>
                                {celda.nombre}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            )}
        </div>
    );
}
